import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useEventsList(){

    const toast = useToast()

    const refEventListTable = ref(null)

    const tableColumns = [
        {key:'image', label:'Image'},
        {key:'has_information', label:'Has Information' , sortable:true},
        {key:'title', label:'Title' , sortable:true},
        {key:'description', label:'Description' , sortable:true},
        {key:'actions'},
        {key:'is_active', label:'Is Active',sortable:true},
        {key:'content', label:'Content' , sortable:true},
    ]

    const perPage = ref(10)
    const totalEvents = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    

    const dataMeta = computed(() => {
        const localItemsCount = refEventListTable.value ? refEventListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1: 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalEvents.value,
        }
    })

    const showMessage = (title,text,icon, variant) =>{
        toast({
            component: ToastificationContent,
            props: {
              title,
              text,
              icon,
              variant
            },
        })
    }

    const refetchData = () =>{
        refEventListTable.value.refresh()
    }

    const getEventImage = (image) =>  process.env.VUE_APP_IMAGE_URL+image

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })


    const event_title = ref(null)
    const event_slug = ref(null)
    const store_name = ref(null)
    const getHasInformation = ref(0)

    const fetchEvents = (ctx, callback) => {

        store.dispatch('bar-event/fetchEvents', {
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response => {
            //console.log(response.data)
            const { events, total} = response.data
            callback(events)
            totalEvents.value = total
            event_title.value = response.data.event_title
            event_slug.value = response.data.event_slug
            store_name.value =  response.data.name
            getHasInformation.value = response.data.has_information
        })
        .catch(() => {
            toast({
                component: ToastificationContent,
                props: {
                  title: 'Error fetching events list',
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
            })
        })
    }

    return {
        fetchEvents,
        tableColumns,
        perPage,
        currentPage,
        totalEvents,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refetchData,
        refEventListTable,
        getEventImage,
        showMessage,
        event_title,
        event_slug,
        store_name,
        getHasInformation
    }

}